import React, { useState, useEffect, useRef, Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import toast, { Toaster } from "react-hot-toast";
import { getCreditNoteList, getCreditNote2 } from "../../../services/index";
import ViewPdf from "../../Common/ViewPdf";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import { generateCreditNoteEInvoice, getApprovedCreditNotes, getCreditNotesHistory } from "../../../services/Sales/CreditNoteService";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import CreateCreditNote from "./CreateCreditNote";
import { getFormattedNumber, searchForMatch } from "../../utils/textUtils";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const CreditNoteView = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [keys, setKeys] = useState("");
  const [values, setValues] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [creditDetails, setCreditDetails] = useState("");
  const [creditNoteList, setCreditNoteList] = useState([]);
  const [creditNoteList2, setCreditNoteList2] = useState([]);
  const [hsnKey, setHsnKey] = useState("");
  const [hsnVal1, setHsnVal1] = useState("");
  const [hsnVal2, setHsnVal2] = useState("");
  const [taxType, setTaxType] = useState("");
  const [orgDetail, setOrgDetail] = useState("");
  const [logData, setLogData] = useState({});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const componentRef = useRef();
  const [CreditNotesListDetails, setCreditNotesListDetails] = useState(null);
  const [index, setIndex] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [logHistory, setLogHistory] = useState([]);


  let org = JSON.parse(localStorage.getItem("orgDetail"));

  useEffect(() => {
    setOrgDetail(org);
    // getCreditNotes();
  }, []);

  useEffect(() => {
    if (invoiceNo) {
      getCreditDetails1(invoiceNo);
    }
  }, [invoiceNo]);

  const getAllCreditNotes = () => {
    let list_data = {
      page: index,
      size: 15,
      search: filterText,
    };
    getCreditNoteList(list_data).then((res) => {
      if (res.errorCode === 0) {
        // res.responsePacket.data.reverse();
        if (index === 0) {
          setCreditNoteList(res.responsePacket.data);
          setCreditNoteList2(res.responsePacket.data);
          // setInvoiceNo(res.responsePacket.data[0].invoiceNo);
        } else {
          const setCreditNotesClone = [
            ...creditNoteList,
            ...res.responsePacket.data,
          ];
          setCreditNoteList(setCreditNotesClone);
          setCreditNoteList2(setCreditNotesClone);
        }
        setIndex(index + 1);
        setCreditNotesListDetails({
          recordsFiltered: res.responsePacket.recordsFiltered,
          recordsTotal: res.responsePacket.recordsTotal,
          total: res.responsePacket.total,
        });
      } else {
        toast(res.message);
      }
    });
  };


  useEffect(() => {
    if (invoiceNo) {
      getAllCreditNotes();
      getCreditDetails1(invoiceNo);
      // getCreditNote2(invoiceNo);
    }
  }, [invoiceNo]);



  useEffect(() => {
    if (creditNoteList.length > 0 && !invoiceNo) {
      setInvoiceNo(creditNoteList[0].invoiceNo);
    }
  }, [creditNoteList]);

  useEffect(() => {
    getAllCreditNotes();
  }, [filterText]);

  const getCreditDetails1 = (invoiceNo) => {
    getCreditNote2(invoiceNo).then((res) => {
      if (res.errorCode === 0) {
        let ddd = res.responsePacket;
        let d = res.responsePacket.creditNoteItemsList;

        var tot = JSON.parse(JSON.stringify(ddd.totalAmount));
        let tot1 = 0;
        let netTax = 0;
        let disTax = 0;
        let disPercent = 0;
        let disAmount = 0;
        let disSubtotal = 0;

        var subtot = JSON.parse(
          JSON.stringify(res.responsePacket.subTotalAmount)
        );

        ddd.shipAdd = ddd.customerAddress;
        // Discount already applied in rate by backend
        tot1 = JSON.parse(JSON.stringify(ddd.totalAmount));
        ddd.discountSubTotal = subtot;
        ddd.discountPercent = 0;
        ddd.discountAmount = 0;

        d.map((a) => {
          a.taxBean.newTax = a.taxBean.taxType + a.taxBean.rate.toString();
          a.taxBean.disAmount = a.taxBean.amount;
          a.disItemAmount = a.amount;
          netTax += a.taxBean.amount;
          disTax += a.taxBean.disAmount;
          disSubtotal += a.disItemAmount;
        });

        let obj = {};
        for (let i = 0; i < d.length; i++) {
          if (obj[d[i].taxBean.newTax]) {
            obj[d[i].taxBean.newTax] += d[i].taxBean.disAmount;
          } else {
            obj[d[i].taxBean.newTax] = d[i].taxBean.disAmount;
          }
        }

        setKeys(Object.keys(obj));
        setValues(Object.values(obj));

        let arr = [];
        Object.keys(obj).map((a, i) => {
          Object.values(obj).map((b, j) => {
            if (i === j) {
              return arr.push({ tax: a, value: b });
            }
          });
        });

        let z = JSON.parse(JSON.stringify(d));

        z.map((a) => {
          a.newHsn = a.hsnSac.toString() + "_" + a.taxBean.newTax;
        });

        let obj2 = {};
        for (let i = 0; i < z.length; i++) {
          if (obj2[z[i].newHsn]) {
            obj2[z[i].newHsn] += z[i].taxBean.disAmount;
          } else {
            obj2[z[i].newHsn] = z[i].taxBean.disAmount;
          }
        }

        let obj3 = {};
        for (let i = 0; i < z.length; i++) {
          if (obj3[z[i].newHsn]) {
            obj3[z[i].newHsn] += z[i].disItemAmount;
          } else {
            obj3[z[i].newHsn] = z[i].disItemAmount;
          }
        }

        setHsnKey(Object.keys(obj2));
        setHsnVal1(Object.values(obj2));
        setHsnVal2(Object.values(obj3));

        let t2 = ddd.totalAmount.toFixed(2).toString()?.split(".")[1];
        if (t2 > 49) {
          ddd.totalAmount += 1;
          let a = 100 - t2;
          ddd.rounding = "+0." + a;
        } else {
          ddd.rounding = "-0." + t2;
        }

        ddd.netTax = netTax;
        ddd.disTax = disTax;

        ddd.taxDetail = arr;

        let localDate = new Date(res?.responsePacket?.invoiceDate)
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");

        if (res?.responsePacket?.creditNoteIssueDate) {
          let localDate2 = new Date(res?.responsePacket?.creditNoteIssueDate)
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("-");
          res.responsePacket.creditNoteIssueDate = localDate2;
        } else {
          res.responsePacket.creditNoteIssueDate = localDate;
        }

        res.responsePacket.invoiceDate = localDate;
        setCreditDetails(res.responsePacket);

        let org = JSON.parse(localStorage.getItem("orgDetail"));
        setOrgDetail(org);
        if (org?.beanAddress?.state === undefined) {
          alert("logged In user's organization address not found ");
        }

        let gst12cust = res.responsePacket.customerGst.substring(0, 2);
        let gst12org = org.gstNumber.substring(0, 2);
        if (gst12cust === gst12org) {
          setTaxType("intra");
        } else {
          setTaxType("inter");
        }
      } else {
        toast(res.message);
      }
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: creditDetails?.invoiceNo,
    pageStyle: "print",
  });

  useEffect(() => {
    if (tabIndex === 1) {
      getCreditNotesHistory(creditDetails.creditNoteNo).then((res) => {
        if (res.errorCode === 0) {
          const resData = res.responsePacket;
          setLogHistory(resData);
        } else {
          toast(res.message);
        }
      }).catch((error) => {
        toast.error("An error occurred while fetching the log history.");
        console.error(error);
      });
    }
  }, [tabIndex, creditDetails.creditNoteNo]);



  const handleApproved = () => {
    const creditNoteUuid = creditDetails.recordId;
    const invoiceNo = creditDetails?.invoiceNo;
    const invoiceId = creditDetails?.invoiceId;
    const data = {
      creditNoteUuid,
      invoiceId,
      invoiceNo,
      creditNoteItemsList: creditDetails?.creditNoteItemsList?.map((item) => ({
        packUnit: item.packUnitTitle,
        itemUuid: item.itemUuid,
        quantity: item.quantity,
        creditNoteItemTypeEnum: item.creditNoteItemTypeEnum,
        unit: item.unit,
      })),
    };

    getApprovedCreditNotes(data).then((res) => {
      if (res.errorCode === 0) {
        toast.success(res.message);
        setCreditDetails((prevCreditDetails) => ({
          ...prevCreditDetails,
          isCreditNoteGenerated: true,
        }));
      } else {
        toast.error(res.message);
      }
    }).catch((error) => {
      toast.error("An error occurred while approved the credit note.");
      console.error(error);
    });
  };


  let time;
  const handleSearch = (e) => {
    const { value } = e.target;
    clearTimeout(time);
    time = setTimeout(() => {
      setIndex(0);
      setFilterText(value);
    }, 500);
  };


  const generateCredit = () => {
    getCreditNote2(creditDetails.invoiceNo).then((res) => {
      if (res.errorCode === 0) {
        generateCreditNoteEInvoice(res.responsePacket).then((res) => {
          if (res.errorCode === 0) {
            getCreditDetails1(invoiceNo);
          } else {
            toast(res.message);
          }
        });
      } else {
        toast(res.message);
      }
    });
  };

  return (
    <>
      <Modal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        size="xl"
      >
        <Modal.Body>
          <CreateCreditNote />
        </Modal.Body>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <table>
            {logData.length === 0 ? (
              "No Changes Found"
            ) : (
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Changes</th>
                </tr>
              </thead>
            )}
            {logData.length >= 1 && (
              <tbody>
                {logData?.map((history, i) => {
                  return (
                    <Fragment key={i}>
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          {history?.transactionDate?.substring(0, 10)}
                          :&nbsp;&nbsp;
                        </td>

                        <td>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: history?.message
                                .replaceAll("\n", "<br />")
                                .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
                            }}
                          />
                        </td>
                      </tr>
                      <hr />
                    </Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
        </Modal.Body>
      </Modal>
      <div
        className="list-column column d-print-none"
        style={{ width: "330px" }}
      >
        <div className="fill list-header topgrad d-print-none">
          <div className="list-filter pt-3 d-flex align-items-center">
            <button
              className="newListBtn"
              onClick={() => setShowCreateModal(true)}
            >
              <AddIcon />
              New
            </button>
            <div className="input-group paginationSearchInput listSearch">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <SearchRoundedIcon />
                </span>
              </div>
              <input
                autoComplete="off"
                className="ember-text-field ember-view form-control"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="scroll-y fill body scrollbox list-body">
          <div className="table-responsive overflow-initial ">
            <table
              id="ember7912"
              className="table zi-table ember-view header-fixed"
            >
              {creditNoteList &&
                (creditNoteList.length > 0 ? (
                  <tbody>
                    {creditNoteList.map((d, i) => (
                      <tr
                        key={i}
                        className={`listTr ${invoiceNo === d.invoiceNo ? "activeRecord" : ""
                          }`}
                        onClick={() => setInvoiceNo(d.invoiceNo)}
                      >
                        <td>
                          <Link
                            className={`${invoiceNo === d.invoiceNo
                              ? "text-primary"
                              : "text-grey"
                              }`}
                          >
                            <span className="titleTr">{d.customerTitle}</span>
                            <span className="d-flex justify-content-between">
                              <span>{d.creditNoteNoAlt}</span>
                              <span>₹ {getFormattedNumber(d.totalAmount)}</span>
                              <span>{d.invoiceNo}</span>
                            </span>
                          </Link>
                        </td>
                      </tr>
                    ))}
                    {CreditNotesListDetails &&
                      CreditNotesListDetails.recordsTotal >
                      creditNoteList.length && (
                        <div className="pt-3">
                          <button
                            className="btn mx-auto newListBtn"
                            onClick={getAllCreditNotes}
                          >
                            Load More
                          </button>
                        </div>
                      )}
                  </tbody>
                ) : (
                  <div className="my-3 text-black text-center">
                    No Data Available!
                  </div>
                ))}
            </table>
          </div>
        </div>
      </div>

      <div className="column content-column" style={{ left: "330px" }}>
        <div className=" header d-flex align-items-center p-4 justify-content-between">
          <div className="listTopHeading">
            <div className="btn-toolbar over-flow text-muted font-xlarge pb-0"> {creditDetails?.creditNoteNoAlt}&nbsp;&nbsp;
            <div
              className="cursor-pointer text-primary font-size-15"
              onClick={() => navigate(`/invoices/${creditDetails.invoiceId}`)}
            >
              ( {creditDetails?.invoiceNo} )
            </div>
            </div>
            </div>
          
          <div className="btn-toolbar d-flex justify-content-end align-items-center">
            <div className="btn-group pr-2">
              <button
                className="tooltip-container ember-view btn btn-primary print-btn mr-0"
                onClick={handlePrint}
              >
                <LocalPrintshopOutlinedIcon />
              </button>
            </div>
            <div className="btn-group pr-2">
              <button
                className="tooltip-container ember-view btn btn-primary print-btn mr-0 me-2"
                onClick={handleApproved}
                style={{
                  backgroundColor: creditDetails.isCreditNoteGenerated ? '#17d7aa' : '',
                  border: creditDetails.isCreditNoteGenerated ? 'none' : '',
                  color: creditDetails.isCreditNoteGenerated ? 'white' : ''
                }}
              >
                <ThumbUpAltIcon
                  style={{
                    color: creditDetails.isCreditNoteGenerated ? 'white' : '',
                    marginRight: 5
                  }}
                />
                <span style={{
                  color: creditDetails.isCreditNoteGenerated ? 'white' : ''
                }}>
                  Approve
                </span>
              </button>
            </div>
            {creditDetails?.isSuccess ? (
              <div className="btn-group">
                <a
                  href={creditDetails?.einvoicePdf}
                  target="_blank"
                  download
                  className="successBtn"
                >
                  GST Credit Note
                </a>
              </div>
            ) : (
              <div className="btn-group">
                <button
                  className="ember-view btn btn-primary d-flex align-items-center"
                  onClick={generateCredit}
                >
                  Generate Credit
                </button>
              </div>
            )}
          </div>
        </div>
      
        <Tabs selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          className="upperTabs">
          <TabList>
            <Tab>Primary Details</Tab>
            <Tab>Log History</Tab>
          </TabList>
          <TabPanel>
            {creditDetails && creditDetails && orgDetail && orgDetail ? (
              <ViewPdf
                handlePrint={handlePrint}
                orderDetail={creditDetails}
                orgDetail={orgDetail}
                itemList={creditDetails.creditNoteItemsList}
                taxType={taxType}
                pdfType={"credit"}
                componentRef={componentRef}
                keys={keys}
                values={values}
                hsnKey={hsnKey}
                hsnVal1={hsnVal1}
                hsnVal2={hsnVal2}
              />
            ) : (
              <></>
            )}
          </TabPanel>
          <TabPanel>
            <div className="ember-view scroll-y noscroll-x fill body scrollbox">
              <table className="customTable">
                {logHistory && logHistory.length === 0 ? (
                  "No Changes Found"
                ) : (
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Changes</th>
                    </tr>
                  </thead>
                )}
                {logHistory && (
                  <tbody>
                    {logHistory.length >= 1 &&
                      logHistory?.map((history, i) => (
                        <tr key={i}>
                          <td style={{ verticalAlign: "top", width: "80px" }}>
                            {history?.transactionDate?.substring(0, 10)}
                            :&nbsp;&nbsp;
                            <br />
                            Time:
                            {history?.transactionDate
                              ?.split("T")[1]
                              ?.substring(0, 5)}
                          </td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: history?.message
                                  .replaceAll("\n", "<br />")
                                  .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
      <Toaster />
    </>
  );
};

export default CreditNoteView;
